export const getReportPath = (reportType) => {
  switch (reportType) {
    case "immunisations":
      return "get/immunisations";
    case "prescriptions":
      return "get/prescriptions";
    // The report keeps its "investigations" key so existing /reports/investigations links still work, but it
    // lists referrals, and the backend serves it at get/referrals (KIN-2147; get/invesgigations is a deprecated alias).
    case "investigations":
      return "get/referrals";
    case "letters":
      return "get/letters";
    case "accounting":
      return "get/accounting";
    case "appointments":
      return "get/appointments";
    case "medico-legal":
      return "get/medico-legal";
    case "audit-log":
      return "get/auditlog";
    case "patient-merges":
      return "get/patient-merges";
    case "cdm-finder":
      return "get/cdm-finder";
    case "cdm-recall":
      return "get/cdm-recall";
    case "cdm-register":
      return "get/cdm-register";
    default:
      return "get/patients";
  }
};
